module.exports = __webpack_public_path__ + "img/avatar6.089fa586.png";